"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Header = exports.Header = _styledComponents["default"].header.withConfig({
  displayName: "Header",
  componentId: "sc-f0r0bu-0"
})(["h1,h2,h3,p{margin-block:0;}@media (max-width:", "){padding:", ";}@media (min-width:", "){padding-block-end:", ";padding-inline:", ";}"], _encoreFoundation.screenXsMax, (0, _index.cssSpacing)('base', '16px'), _encoreFoundation.screenSmMin, _index.sidebarPadding, _index.sidebarPadding);